// src/lib/dateUtils.ts

/**
 * Detects YYYY-MM-DD format
 */
const isDateOnly = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value);

/**
 * Parse a UTC timestamp safely
 */
export const parseUtc = (value: string | Date | null | undefined): Date | null => {
  if (!value) return null;

  if (value instanceof Date) return value;

  // SQL date-only fix
  if (isDateOnly(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }

  return new Date(value);
};

/**
 * Format local date (no time)
 */
export const fmtLocalDate = (value: string | Date | null | undefined): string => {
  const d = parseUtc(value);
  if (!d) return "-";

  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  });
};

/**
 * Format local datetime
 */
export const fmtLocalDateTime = (value: string | Date | null | undefined): string => {
  const d = parseUtc(value);
  if (!d) return "-";

  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
};

/**
 * Compute DTE between two dates
 */
export const computeDte = (
  expiration: string | Date | null | undefined,
  today?: Date
): number | null => {
  const exp = parseUtc(expiration);
  if (!exp) return null;

  const now = today ?? new Date();
  const diff = exp.getTime() - now.getTime();

  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};